<template>
  <li class="profile">
    <img
      ref="image"
      :src="profileImage"
      :class="'image-profile'"
    />
    <p class="company">
      {{ providerName }}
    </p>
    <p v-if="!isRuejaiPartnerAdmin" class="title">
      {{ `${firstName} ${lastName}` }}
    </p>
  </li>
</template>

<script>
import { permissionRole } from "../../lib/mapper";

export default {
  name: "SupplierProfile",
  data() {
    return {
      roleId: parseInt(localStorage.getItem("supplierRoleId"), 10),
      imageProfile: localStorage.getItem("supplierProviderImage"),
      providerName: localStorage.getItem("supplierProviderName"),
      firstName: localStorage.getItem("supplierFirstName"),
      lastName: localStorage.getItem("supplierLastName")
    };
  },
  computed: {
    profileImage() {
      if (this.isRuejaiPartnerAdmin) {
        return "/static/pictures/mock/sc-profile.jpg";
      }

      return this.imageProfile;
    },
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.profile {
  padding-block: 24px;
  padding-inline: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-profile {
  width: 64px;
  height: 64px;
  border: solid 1px #e0e0e0;
  border-radius: 50%;
  background-color: $white;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.company {
  font-size: $font-16;
  font-weight: bold;
  text-align: center;
  line-height: 1.5;
  color: $black;
  margin-top: 12px;
}

.title {
  font-size: $font-14;
  text-align: center;
  line-height: 1.5;
  color: $color-gray;
}

@media (max-width: ($m-size - 1)) {
  .profile {
    padding-block: 16px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .profile {
    padding-block: 16px;
    padding-inline: 8px;
  }

  .company {
    font-size: $font-14;
  }

  .title {
    font-size: $font-12;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .profile {
    padding-block: 20px;
  }

  .company {
    font-size: $font-14;
  }

  .title {
    font-size: $font-12;
  }
}
</style>
